import { render } from "./PopupTechnicalWork.vue?vue&type=template&id=be2b183a&scoped=true"
import script from "./PopupTechnicalWork.vue?vue&type=script&lang=js"
export * from "./PopupTechnicalWork.vue?vue&type=script&lang=js"

import "./PopupTechnicalWork.vue?vue&type=style&index=0&id=be2b183a&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2b183a"]])

export default __exports__